import { createActionTypes } from "@helpers/redux-helpers";

export const notificationReceiveCountActionType = "notifications/receiveCount";

export const getNotificationActionType = createActionTypes(
  "notifications/getList",
);

export const getNotificationCountActionType = createActionTypes(
  "notifications/count",
);

export const getPortionNotificationActionType = createActionTypes(
  "notifications/getListPortion",
);

export const hideNotificationActionType =
  createActionTypes("notifications/hide");

export const readNotificationsActionType =
  createActionTypes("notifications/read");

export const newNotificationReceivedActionTypes = createActionTypes(
  "notifications/receive/new",
);
